// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"850982af","644":"a8b433d2","984":"280366c2"}[chunkId] + ".chunk.js";
};